import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { arrayRemove, arrayUpsert, setLoading } from '@datorama/akita';
import { JComment } from '@trungk18/interface/comment';
import { Issue } from '@trungk18/interface/issue';
import { JProject } from '@trungk18/interface/project';
import { DateUtil } from '@trungk18/project/utils/date';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ProjectStore } from './project.store';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  baseUrl: string;

  constructor(private _http: HttpClient, private _store: ProjectStore) {
    this.baseUrl = environment.apiUrl;
  }

  setLoading(isLoading: boolean) {
    this._store.setLoading(isLoading);
  }

  updateProject(project: Partial<JProject>) {
    this._store.update((state) => ({
      ...state,
      ...project
    }));
  }

  updateIssue(issue: Issue) {
    issue.updatedAt = DateUtil.getNow();
    this._store.update((state) => {
      const issues = arrayUpsert(state.issues, issue._id, issue);
      return {
        ...state,
        issues
      };
    });
  }

  

  // deleteIssue(issueId: string) {
  //   this._store.update((state) => {
  //     const issues = arrayRemove(state.issues, issueId);
  //     return {
  //       ...state,
  //       issues
  //     };
  //   });
  // }

  // updateIssueComment(issueId: string, comment: JComment) {
  //   const allIssues = this._store.getValue().issues;
  //   const issue = allIssues.find((x) => x.id === issueId);
  //   if (!issue) {
  //     return;
  //   }

  //   const comments = arrayUpsert(issue.comments ?? [], comment.id, comment);
  //   this.updateIssue({
  //     ...issue,
  //     comments
  //   });
  // }
}
